// extracted by mini-css-extract-plugin
export default {"noiseOverlay":"NoiseOverlay_noiseOverlay__gxYL+"};